import { ScrollStrategy, ScrollStrategyOptions } from "@angular/cdk/overlay";
import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject, Observable } from "rxjs";
import { DanhSachDonHangComponent } from "../danh-sach-don-hang/danh-sach-don-hang.component";
import { DynamicTabsDirective } from "../../shared/directives/dynamic-tabs.directive";
import {
  OrderChanelEnum,
  OrderCustomerModel,
  OrderTypeEnum,
  PaymentTypeEnum,
  ProductDto,
  TokenPayload,
} from "../../shared/api-connector/sso-connector";
import { TabOrderValue } from "../../shared/model/tab-order";
import { AlertService } from "../../shared/services/alert.service";
import { AuthService } from "../../shared/services/auth.service";
import { EventEmitterService } from "../../shared/services/event.emitter.service";
import { AddNewHangHoaDrawerComponent } from "../add-new-hang-hoa-drawer/add-new-hang-hoa-drawer.component";
import { OrderContentDynamicComponent } from "../order-content-dynamic/order-content-dynamic.component";
import { DrawerService } from "../../shared/components/drawer/drawer.service";

@Component({
  selector: "app-sales",
  templateUrl: "./sales.component.html",
  styleUrls: ["./sales.component.scss"],
})
export class SalesComponent implements OnInit {
  productCtrl = new FormControl(null);
  activeId: string = "";
  tabs: TabOrderValue<OrderCustomerModel, OrderContentDynamicComponent>[] = [];
  productSelected!: ProductDto;
  reloadProductComponent: any;

  // UI States
  isMenuOpen = false;
  isShowSearchMobile = false;
  isShowUserMenu = false;

  orderCustomerModel = new OrderCustomerModel();
  public selectedId$!: BehaviorSubject<boolean>;
  public players$!: BehaviorSubject<OrderContentDynamicComponent[]>;
  public player$!: Observable<OrderContentDynamicComponent>;

  account: TokenPayload;

  get currentTabIndex(): number {
    return this.tabs.findIndex((x) => x.key === this.activeId);
  }

  onTabChange(event: any): void {
    if (event.index < this.tabs.length) {
      this.selectedTab(this.tabs[event.index]);
    }
  }
  @ViewChild("container", {
    read: ViewContainerRef,
    static: true,
  })
  container!: ViewContainerRef;
  scrollStrategy!: ScrollStrategy;
  componentRef!: ComponentRef<OrderContentDynamicComponent>;
  dynamicContents: OrderContentDynamicComponent[] = [];
  tabName: string = "Hóa đơn";
  tabCounter: number = 1;

  @ViewChild("productSearch") productSearch: any;
  @ViewChild(DynamicTabsDirective, { static: true })
  dynamicTabPlaceholder!: DynamicTabsDirective;

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === "F6" || event.keyCode === 117) {
      event.preventDefault();
      if (this.productSearch) {
        this.productSearch.focus();
      }
    }
  }

  constructor(
    public authService: AuthService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    private eventEmitterService: EventEmitterService,
    private alertService: AlertService,
    private renderer: Renderer2,
    private drawerService: DrawerService
  ) {
    if (this.authService.getAccount().laKhachHang) {
      this.tabName = "Đặt hàng";
    }

    this.renderer.listen("window", "click", (e: any) => {
      // Close user menu if clicked outside
      if (
        !e.target.closest(".user-info") &&
        !e.target.closest(".menu-trigger")
      ) {
        this.isShowUserMenu = false;
      }

      if (
        !e.target.classList.contains("fa-bars") &&
        !e.target.classList.contains("list-bar") &&
        !e.target.classList.contains("icon-link-custom")
      ) {
        this.isMenuOpen = false;
      }
    });

    this.account = this.authService.getAccount();
    this.setInvoiceDefault(this.orderCustomerModel);

    this.eventEmitterService.getEvent().subscribe((data: any) => {
      setTimeout(() => {
        this.reloadProductComponent = data;
      }, 100);
    });
  }

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
    // Start auto-save periodic check (every 2 seconds)
    setInterval(() => {
      this.autoSaveDrafts();
    }, 2000);
  }

  ngAfterViewInit() {
    const hasDrafts = this.loadDrafts();

    if (!hasDrafts) {
      this.renderComponent();
      this.activeId = "order_tab1";
      this.tabs.push(
        new TabOrderValue({
          key: "order_tab1",
          data: this.orderCustomerModel,
          content: this.dynamicContents[0],
          isRemove: false,
          name: `${this.tabName} 1`,
        }),
      );

      if (this.dynamicContents.length > 0) {
        this.selectTabContent(this.dynamicContents[0]!);
      }
    }
  }

  renderComponent() {
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory(
        OrderContentDynamicComponent,
      );
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
    const componentRef = viewContainerRef.createComponent(componentFactory);
    const instance: OrderContentDynamicComponent =
      componentRef.instance as OrderContentDynamicComponent;

    let orderModel = new OrderCustomerModel();
    this.setInvoiceDefault(orderModel);
    instance.orderCustomerModel = orderModel;
    this.orderCustomerModel = orderModel; // Sync active model
    instance.paymentTypeCtrl.setValue(0);
    this.componentRef = componentRef;
    componentRef.instance.eventEmitter = this.eventEmitterService;
    this.dynamicContents.push(
      componentRef.instance as OrderContentDynamicComponent,
    );
  }

  selectedTab(
    item: TabOrderValue<OrderCustomerModel, OrderContentDynamicComponent>,
  ): void {
    this.activeId = item.key;
    if (item.content) {
      this.selectTabContent(item.content!);
    }
  }

  newPane() {
    this.renderComponent();
    this.tabCounter++;
    const newIdx = this.tabCounter;
    const newKey = "order_tab" + newIdx;

    const newTab = new TabOrderValue({
      key: newKey,
      data: this.orderCustomerModel,
      content: this.dynamicContents[this.dynamicContents.length - 1]!,
      isRemove: true,
      name: `${this.tabName} ${newIdx}`,
    });
    this.tabs.push(newTab);
    this.selectedTab(newTab);
  }

  closeTab(
    item: TabOrderValue<OrderCustomerModel, OrderContentDynamicComponent>,
    event: Event,
  ) {
    event.stopPropagation();
    if (!item || item.isRemove === false) return;

    if (item.content?.orderCustomerModel.orderItemCustomers.length > 0) {
      this.alertService
        .confirm("Bạn có chắc là muốn đóng hóa đơn này không", "Đóng hóa đơn")
        .subscribe((x: any) => {
          if (x) {
            this.removeTab(item);
          }
        });
    } else {
      this.removeTab(item);
    }
  }

  removeTab(
    item: TabOrderValue<OrderCustomerModel, OrderContentDynamicComponent>,
  ) {
    const idx = this.tabs.indexOf(item);
    if (idx === -1) return;

    // Find matching dynamic content
    if (item.content) {
      const contentIdx = this.dynamicContents.indexOf(item.content);
      if (contentIdx !== -1) {
        this.dynamicContents.splice(contentIdx, 1);
        this.dynamicTabPlaceholder.viewContainer.remove(contentIdx);
      }
    }

    this.tabs.splice(idx, 1);
    this.autoSaveDrafts(); // Update storage immediately after removal

    // Adjust active tab
    if (this.tabs.length > 0) {
      this.selectedTab(this.tabs[this.tabs.length - 1]!);
    }
  }

  selectTabContent(tabContent: OrderContentDynamicComponent) {
    if (!tabContent) return;
    this.dynamicContents.forEach((tab) => (tab.active = false));
    tabContent.active = true;
  }

  openAddHangHoa() {
    const drawerRef = this.drawerService.open(AddNewHangHoaDrawerComponent, {
      title: 'Thêm mới hàng hóa',
      width: 'min(750px, 90vw)',
      disableClose: true
    });

    drawerRef.afterClosed().subscribe((x) => {
      if (x) {
        this.reloadProductComponent = x;
      }
    });
  }

  setInvoiceDefault(orderCustomerModel: OrderCustomerModel) {
    orderCustomerModel.createdId = this.authService.getAccount().id;
    orderCustomerModel.orderChannel = OrderChanelEnum.BAN_TRUC_TIEP;
    orderCustomerModel.orderType = OrderTypeEnum.BAN_NHANH;
    orderCustomerModel.discount = 0;
    orderCustomerModel.orderTotal = 0;
    orderCustomerModel.price = 0;
    orderCustomerModel.quantity = 0;
    orderCustomerModel.payingAmtInvoice = 0;
    orderCustomerModel.orderTime = new Date();
    orderCustomerModel.orderItemCustomers = [];
    orderCustomerModel.paymentTypeEnum = PaymentTypeEnum.TIEN_MAT;
  }

  laKhachHang(): boolean {
    return this.authService.getAccount().laKhachHang;
  }

  selectedProduct(item: ProductDto) {
    if (!item) return; // Don't reset if no product is selected (could be just typing)

    this.productSelected = item;
    let tabSelected = this.dynamicContents.filter((tab) => tab.active === true);
    if (tabSelected.length > 0) {
      tabSelected[0].selectedProduct(item);
    }
    this.productCtrl.setValue(null); // Use null instead of "" for consistency
    this.isShowSearchMobile = false; // Close mobile search after selection
  }

  onLogout() {
    this.alertService
      .confirm(
        "Bạn có chắc là muốn thoát ra khỏi hệ thống không ?",
        "Đăng xuất hệ thống",
      )
      .subscribe((x: any) => {
        if (x) {
          this.authService.logout();
        }
      });
  }

  lstOrder() {
    this.dialog.open(DanhSachDonHangComponent, {
      panelClass: "custom-dialog",
      minWidth: "70%",
      height: "auto",
      disableClose: true,
      scrollStrategy: this.scrollStrategy,
    });
  }

  openMenuBar(event: MouseEvent) {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  autoSaveDrafts() {
    const account = this.authService.getAccount();
    if (!account || !account.id) return;

    const draftData = this.tabs
      .map((tab) => {
        return {
          key: tab.key,
          name: tab.name,
          isRemove: tab.isRemove,
          state: tab.content ? tab.content.exportState() : null,
        };
      })
      .filter((d) => d.state !== null);

    const tabsWithProducts = draftData.filter((d) => {
      const model = d.state?.orderCustomerModel;
      if (!model) return false;
      const items = model.orderItemCustomers || model.OrderItemCustomers;
      return Array.isArray(items) && items.length > 0;
    });

    if (tabsWithProducts.length > 0) {
      localStorage.setItem(
        `DRAFT_ORDERS_${account.id}`,
        JSON.stringify(tabsWithProducts),
      );
    } else {
      // If no product in any tab, clear the storage for this account
      localStorage.removeItem(`DRAFT_ORDERS_${account.id}`);
    }
  }

  loadDrafts(): boolean {
    const account = this.authService.getAccount();
    if (!account || !account.id) return false;

    const saved = localStorage.getItem(`DRAFT_ORDERS_${account.id}`);
    if (saved) {
      try {
        const draftData = JSON.parse(saved);
        if (draftData && draftData.length > 0) {
          // Clear default state before restoring
          this.tabs = [];
          if (this.dynamicTabPlaceholder?.viewContainer) {
            this.dynamicTabPlaceholder.viewContainer.clear();
          }
          this.dynamicContents = [];
          this.tabCounter = 0;

          draftData.forEach((draft: any) => {
            this.renderComponent();
            const component =
              this.dynamicContents[this.dynamicContents.length - 1];
            if (component) {
              component.applyState(draft.state);
              const newTab = new TabOrderValue({
                key: draft.key,
                data: component.orderCustomerModel,
                content: component,
                isRemove: draft.isRemove,
                name: draft.name,
              });
              this.tabs.push(newTab);

              // Update tab counter to avoid key conflict
              const match = draft.key.match(/order_tab(\d+)/);
              if (match) {
                const num = parseInt(match[1]);
                if (num > this.tabCounter) this.tabCounter = num;
              }
            }
          });

          if (this.tabs.length > 0) {
            this.selectedTab(this.tabs[0]);
            this.activeId = this.tabs[0].key;
            return true;
          }
        }
      } catch (e) {
        console.error("Error loading draft orders:", e);
        return false;
      }
    }
    return false;
  }
}
